import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8","key":"svg-1"}]]

const IconWashDryW = createReactComponent('outline', 'wash-dry-w', 'WashDryW', __iconNode);

export default IconWashDryW;